export default __webpack_public_path__ + "static/bugswork-dark-6a84e916b100d3ea80515c2ce104eb18.svg";